module.exports = __webpack_public_path__ + "static/media/european_roulette.netent.5714f6a7.jpeg";